import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { setError, setLoaded, setLoading, withCallState, withReset } from '@ngrx-toolkit/core';
import { inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { PaymentService } from './payment.service';
import { AlertService } from '@td/components/alert';
import type { PayLaterData } from '../../pages/pay-later/shared/types';
import { AuthStore } from '../../../../core';

type State = {
  payLaterStatus: (PayLaterData & { submittedAt: string }) | null;
};

const initialState: State = {
  payLaterStatus: null,
};

export const PaymentStore = signalStore(
  { providedIn: 'root' },
  withCallState(),
  withReset(),
  withState(initialState),
  withMethods((store, api = inject(PaymentService), alert = inject(AlertService)) => ({
    loadUrl: rxMethod<void>(
      pipe(
        tap(() => patchState(store, setLoading())),
        switchMap(() =>
          api.getPaymentUrl().pipe(
            tapResponse({
              next: (paymentUrl) => {
                patchState(store, setLoaded());
                window.location.href = paymentUrl;
              },
              error: (error) => {
                patchState(store, setError(error));
                alert.warning('ticketOptions.payFine.payment-unavailable');
              },
            }),
          ),
        ),
      ),
    ),
    payLater: rxMethod<PayLaterData>(
      pipe(
        tap(() => patchState(store, setLoading())),
        switchMap((data) =>
          api.submitPayLater(data).pipe(
            tapResponse({
              next: (payLaterStatus) => patchState(store, setLoaded(), { payLaterStatus }),
              error: (error) => patchState(store, setError(error)),
            }),
          ),
        ),
      ),
    ),
    getPayLaterStatus: rxMethod<void>(
      pipe(
        tap(() => patchState(store, setLoading())),
        switchMap(() =>
          api.getPayLaterStatus().pipe(
            tapResponse({
              next: (payLaterStatus) => {
                patchState(store, setLoaded(), { payLaterStatus });
              },
              error: (error) => patchState(store, setError(error)),
            }),
          ),
        ),
      ),
    ),
  })),
  withHooks({
    onInit(store, authStore = inject(AuthStore)) {
      authStore.logout$.subscribe(() => store.resetState());
    },
  }),
);
